module.exports = __webpack_public_path__ + "media/images/analytics_icons/analytic_reuse_chair3-5e608248b24c8c19b8883c37320295ab.png";